import { AnimatePresence, motion } from 'framer-motion'
import { useContext } from 'react'
import { EnhancedMenu } from '../../lib/menus'
import { HeaderContext } from '../header/header-provider.client'
import styles from '../../assets/scss/components/mobile-menu.module.scss'
import { ParentMenu } from './parent-menu.client'
import { ChildMenu } from './child-menu.client'
import { BreakpointsContext } from '../layout/breakpoints-provider.client'

export const MobileMenu: React.FC<{ menu: EnhancedMenu }> = ({ menu }) => {
  const { isMainNavigationOpen } = useContext(HeaderContext)
  const { isLargeUp } = useContext(BreakpointsContext)

  if (isLargeUp) {
    return null
  }

  return (
    <AnimatePresence>
      {isMainNavigationOpen && (
        <motion.div
          animate={{ translateY: 0 }}
          className={styles.menuDrawer}
          exit={{ translateY: '-100%', transition: { ease: [1, 0, 1, 1] } }}
          initial={{ translateY: '-100%' }}
          role="navigation"
          transition={{ ease: [0, 0, 0, 1] }}>
          <ParentMenu menu={menu} />
          <ChildMenu menu={menu} />
        </motion.div>
      )}
    </AnimatePresence>
  )
}
